import  { Auth,Logger } from 'aws-amplify';
import { AmplifyEventBus } from 'aws-amplify-vue'
const logger = new Logger('MQTT','INFO');
const awsIoTData = require('aws-iot-device-sdk')
const awsMobileConfig = require('../aws-exports.js')
const markConfig = require('../markConfig.js')
const mqttConfig={
    region: awsMobileConfig.default.aws_project_region,
    host:markConfig.default.iotHost,
    protocol: 'wss',
    maximumReconnectTimeMs: 8000,
    debug: false,
    accessKeyId: '',
    secretKey: '',
    sessionToken: '',
    websocketOptions:{},
}

export const MqttMixins = {
    data() {
        return {
            mqttClient:undefined,
            reconnectAteemptedNum:0,
            topic:""
        }
    },
    methods: {
        getCredential: async function () {
            const anonymousUser = await Auth.currentCredentials()
            this.cognitoId = anonymousUser.identityId
            const cred = Auth.essentialCredentials(anonymousUser)
            this.topic = "adt-consumers/user/"+this.cognitoId
            return cred
        },
        setupMqttClient: async function () {
            const cred = await this.getCredential()
            mqttConfig.accessKeyId = cred.accessKeyId
            mqttConfig.secretKey = cred.secretAccessKey
            mqttConfig.sessionToken = cred.sessionToken
            // Must read for recconection :
            // https://github.com/mqttjs/MQTT.js#signed-websocket-urls
            this.mqttClient = awsIoTData.device(mqttConfig)
            //mqttClient.updateWebSocketCredentials(cred.accessKeyId,cred.secretAccessKey,cred.sessionToken)
            this.mqttClient.on('connect', this.mqttConnectHandler)
            this.mqttClient.on('reconnect', this.mqttReconnectHandler)
            this.mqttClient.on('message', this.mqttMessageHandler)
            this.mqttClient.on('close', this.mqttCloseHandler)
            this.mqttClient.on('disconnect', this.mqttDisconnectHandler)
            this.mqttClient.on('offline', this.mqttOfflineHandler)
            this.mqttClient.on('error', this.mqttErrorHandler)
            this.mqttClient.on('end', this.mqttEndHandler)
            // there is also packetsend, packetreceive
        },

        mqttCloseHandler: function () {
            logger.info("MQTT close")
        },
        mqttDisconnectHandler: function (packet) {
            logger.info("MQTT disconnect", packet)
        },
        mqttOfflineHandler: function () {
            logger.info("MQTT offline")

        },
        mqttErrorHandler: async function (err) {
            logger.info("MQTT error", err)
            const cred = await this.getCredential()
            this.mqttClient.updateWebSocketCredentials(
                cred.secretAccessKey, cred.secretAccessKey, cred.sessionToken
            )
            if (this.reconnectAteemptedNum >= 2 && this.reconnectAteemptedNum <= 3) {
                logger.info("mqtt reconnect with refreshed")
                await this.mqttClient.end(true)
                await this.setupMqttClient()
            }
            if (this.reconnectAteemptedNum >= 6) {
                logger.info("location reload")
                // consider to jump to non-mqtt error page to avoid spamming
                location.reload()
            }
        },
        mqttEndHandler: function () {
            logger.info("MQTT end")
        },
        mqttConnectHandler: function () {
            logger.info("MQTT connect. Susbscribe topic")
            this.reconnectAteemptedNum = 0
            this.mqttClient.subscribe(this.topic)
            const helloMsg = {
                "msg": "hello from client",
                "clientId": this.mqttClientId,
                "cognitoId": this.cognitoId
            }
            this.mqttClient.publish(this.topic, JSON.stringify(helloMsg))
        },
        mqttReconnectHandler: async function () {
            logger.info("MQTT Reconnecting. reconnectAteemptedNum: ", this.reconnectAteemptedNum)
            if (this.reconnectAteemptedNum >= 6) {
                logger.info("location reload")
                location.reload()
            }
            this.reconnectAteemptedNum += 1
        },
        mqttMessageHandler: function (topic, payloadChunk) {
            logger.info("MQTT message." + topic + ": " + payloadChunk.toString())
            const payload = JSON.parse(payloadChunk.toString())
            AmplifyEventBus.$emit("mqttMessage",payload)

        },
    }
}

